import * as reducers from './reducers';

const LOGIN = 'login';
const LOGOUT = 'logout';

const actionReducerMap = {};
actionReducerMap[LOGIN] = reducers.login;
actionReducerMap[LOGOUT] = reducers.logout;

export {LOGIN, LOGOUT, actionReducerMap};